"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countChildren = countChildren;
var _react = _interopRequireDefault(require("react"));
var _reactHotLoader = require("react-hot-loader");
function countChildren(children, type) {
  var childCount = 0;
  _react.default.Children.forEach(children, function (child) {
    if (child && (0, _reactHotLoader.areComponentsEqual)(child.type, type)) {
      childCount += 1;
    }
  });
  return childCount;
}
//# sourceMappingURL=children.js.map